import React from 'react';
export const Hero = () => {
  return <section className="py-6 sm:py-8" data-id="element-117">
      <h1 className="text-2xl sm:text-3xl font-bold text-[#E55A88] mb-3" data-id="element-118">
        "Doctor Tells Menopausal Woman to 'Just Deal With It'... So She Found a
        Solution That Actually Works"
      </h1>
      <div className="flex items-center text-sm text-gray-600 mb-5" data-id="element-119">
        <div className="w-8 h-8 overflow-hidden rounded-full mr-2" data-id="element-120">
          <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80" alt="Dr. Sarah Chen" className="w-full h-full object-cover" data-id="element-121" />
        </div>
        <span data-id="element-122">Dr. Sarah Chen • Chief Medical Officer</span>
      </div>
      <h2 className="text-lg sm:text-xl text-gray-700 mb-5 font-medium italic" data-id="element-123">
        "The breakthrough discovery that addresses hot flashes, weight gain,
        mood swings, brain fog, and sleep issues with ONE scientifically-backed
        approach."
      </h2>
      <div className="mb-6" data-id="element-124">
        <img src="https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Middle-aged woman looking tired and frustrated" className="w-full h-auto rounded-md" data-id="element-125" />
      </div>
      <div className="prose max-w-none text-base" data-id="element-126">
        <p data-id="element-127">
          Margaret sat in her doctor's office listing her symptoms for the third
          time: night sweats, weight gain, mood swings, brain fog.
        </p>
        <p data-id="element-128">
          Her doctor's response?{' '}
          <strong data-id="element-129">"Just deal with it. It's menopause."</strong>
        </p>
        <p data-id="element-130">
          Margaret left feeling invisible. Like her suffering didn't matter.
        </p>
        <p data-id="element-131">
          She had no idea she was about to discover something that would change
          everything...
        </p>
      </div>
    </section>;
};